import type { SVGProps } from 'react';

const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M5.65 15.9c-.72-.73-1.89-.73-2.61 0s-.72 1.91 0 2.63l11.82 11.92c.72.73 1.89.73 2.61 0l11.82-11.92c.72-.73.72-1.91 0-2.63-.72-.73-1.89-.73-2.61 0l-8.67 8.74V.83h-3.7v23.81L5.65 15.9Z"
    />
  </svg>
);

export default SvgArrowDown;
